var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkPagamentoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6637 17H8.77188C8.32868 17.0003 7.8994 17.1548 7.55767 17.4369C7.21594 17.7191 6.98305 18.1114 6.89895 18.5464C6.81484 18.9815 6.88477 19.4323 7.09673 19.8214C7.30869 20.2106 7.64948 20.5139 8.06064 20.6793L10.9966 21.8526C11.4085 22.0173 11.7501 22.3203 11.9628 22.7095C12.1755 23.0987 12.246 23.5498 12.1621 23.9853C12.0783 24.4209 11.8454 24.8136 11.5035 25.0961C11.1615 25.3786 10.7318 25.5332 10.2882 25.5333H7.39635",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52979 17.0003V15.9336",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52979 26.5998V25.5332",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7886 12.8244C10.3717 12.7638 9.95099 12.7334 9.52972 12.7334C8.35077 12.7341 7.18475 12.979 6.10517 13.4527C5.02559 13.9263 4.05587 14.6185 3.25715 15.4855C2.45843 16.3525 1.84802 17.3756 1.46442 18.4902C1.08082 19.6048 0.932341 20.7868 1.02835 21.9616C1.12435 23.1365 1.46276 24.2787 2.02223 25.3162C2.58171 26.3538 3.35011 27.2642 4.27901 27.9901C5.2079 28.716 6.27713 29.2416 7.41929 29.5338C8.56145 29.8259 9.75177 29.8783 10.9152 29.6877",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7328 6.33336H20.1981C19.0663 6.33336 17.9808 6.78288 17.1806 7.58304C16.3803 8.38319 15.9307 9.46843 15.9307 10.6V24.4667C15.9307 26.7299 16.8299 28.9003 18.4304 30.5007C20.031 32.101 22.2019 33 24.4655 33C26.729 33 28.8999 32.101 30.5005 30.5007C32.101 28.9003 33.0002 26.7299 33.0002 24.4667V10.6C33.0002 9.46843 32.5506 8.38319 31.7504 7.58304C30.9501 6.78288 29.8646 6.33336 28.7328 6.33336Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4658 10.6V14.8666",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0293 3.57422L13.5385 5.0832",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.998 3.13333V1",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4541 8.4668H11.5878",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPagamentoIcon);
export default __webpack_public_path__ + "static/media/link-pagamento-icon.1c3e013468d0d58e3d2fa916c53a6058.svg";
export { ForwardRef as ReactComponent };